export function initTwoColSection() {
  if (typeof Swiper === "undefined") {
    return;
  }

  const sectionEls = document.querySelectorAll(".two-col-section");
  if (!sectionEls.length) {
    return;
  }

  const mobileQuery = window.matchMedia("(max-width: 599px)");
  const viewportHandlers = [];

  sectionEls.forEach((sectionEl) => {
    const sliderEl = sectionEl.querySelector(".swiper");
    if (!sliderEl) {
      return;
    }

    const slideCount = sliderEl.querySelectorAll(".swiper-slide").length;
    if (slideCount <= 1) {
      return;
    }

    const btnPrev = sliderEl.querySelector(".two-col-section_swiper-nav__prev");
    const btnNext = sliderEl.querySelector(".two-col-section_swiper-nav__next");

    let swiperInstance = null;

    const initSwiper = () => {
      if (swiperInstance) {
        return;
      }

      swiperInstance = new Swiper(sliderEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        watchOverflow: true,
        loop: true,
        navigation: {
          prevEl: btnPrev,
          nextEl: btnNext,
        },
      });
    };

    const destroySwiper = () => {
      if (!swiperInstance) {
        return;
      }
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    };

    const handleViewportChange = () => {
      if (mobileQuery.matches) {
        initSwiper();
      } else {
        destroySwiper();
      }
    };

    viewportHandlers.push(handleViewportChange);
    handleViewportChange();
  });

  const onMediaChange = () => {
    viewportHandlers.forEach((handler) => handler());
  };

  if (typeof mobileQuery.addEventListener === "function") {
    mobileQuery.addEventListener("change", onMediaChange);
  } else {
    mobileQuery.addListener(onMediaChange);
  }
}
